<template>
    <PopupTemplate
        v-if="shouldShow"
        v-model="isOpen"
        :img-src="imgSrc"
        img-alt="Trial ended"
        :title="t('vue.your_trial_ended')"
        :body-text="t('vue.your_trial_ended_action_step')"
        :emphasis-text="t('vue.your_trial_ended_action_step_continue')"
        @close="dismissed = true"
    >
        <template #actions>
            <AtomicButton
                color="yellow"
                size="lg"
                class="border-transparent bg-[#088BEA] text-white hover:text-gray-100 focus:ring-[#088BEA] disabled:bg-gray-300 disabled:text-white"
                @click="choosePlan"
            >
                {{ t("vue.choose_dmarceye_plan") }}
            </AtomicButton>
        </template>
    </PopupTemplate>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { router, usePage } from "@inertiajs/vue3";
import route from "ziggy-js";

import PopupTemplate from "@/components/Atomic/Dialogs/PopupTemplate.vue";
import AtomicButton from "@/components/Atomic/Buttons/AtomicButton.vue";
import { useTranslations } from "@/composables/useTranslations";
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";

const { t } = useTranslations();
const page = usePage<IRhizomPageProps>();

// trial expired condition: vše musí být false
const shouldShow = computed(() => {
    const isTrialing = page.props.isTrialing;
    const hasScalePlan = page.props.hasScalePlan;
    const hasBasicPlan = page.props.hasBasicPlan;
    const hasGodMode = page.props.hasGodMode;

    return !isTrialing && !hasScalePlan && !hasBasicPlan && !hasGodMode;
});

const imgSrc = new URL(
    "/resources/js/assets/images/plan-calendar.svg",
    import.meta.url,
).href;

const isOpen = ref(false);
const dismissed = ref(false);

watch(
    shouldShow,
    (show) => {
        if (!show) {
            dismissed.value = false;
            isOpen.value = false;
            return;
        }
        if (!dismissed.value) isOpen.value = true;
    },
    { immediate: true },
);

watch(isOpen, (openNow) => {
    if (!openNow) dismissed.value = true;
});

function choosePlan() {
    router.visit(route("billing.subscriptions.index"));
    isOpen.value = false;
    dismissed.value = true;
}
</script>
